// FROM: https://github.com/modusign/modusign-client/blob/b6c3d577fdd8384ea2f73c5ab605ead1afc782d1/app/src/components/MouseFieldPlaceholder/SignatureMousePlaceholder/index.tsx

import { SignatureType } from '@modusign/react-signing/types';

import { AbsoluteSize } from '@app/features/apply-react-signing/components/FieldRenderer/types';
import { SignatureFieldPlaceholder } from '@app/features/apply-react-signing/components/FieldSetupStep/Placeholders/SignatureFieldPlaceholder';

interface SignatureMousePlaceholderProps {
  allow: SignatureType[];
  uploadOnly: boolean;
  participantOrder: number;
  size: AbsoluteSize;
}

const defaultProps = {
  allowSignatureTypes: [],
  index: 0,
};

function SignatureMousePlaceholder({
  allow,
  uploadOnly,
  size,
  participantOrder,
}: SignatureMousePlaceholderProps) {
  if (allow.every((a) => a === undefined)) {
    return null;
  }

  return (
    <SignatureFieldPlaceholder
      allow={allow}
      participantOrder={participantOrder}
      size={size}
      uploadOnly={uploadOnly}
    />
  );
}

SignatureMousePlaceholder.defaultProps = defaultProps;

export default SignatureMousePlaceholder;
